import React, { useEffect, useMemo } from "react";
import Animated, {
  Easing,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from "react-native-reanimated";

import { palette, spacing } from "../styles";
import Block from "./Block";

type Props = {
  size?: number;
  borderRadius?: number;
  backgroundColor?: string;
};

const CirclePlaceholder = ({
  size = 10,
  borderRadius = 10,
  backgroundColor = palette.common.disabled,
}: Props) => {
  const pulse = useSharedValue(0);
  const placeholderSize = useMemo(() => spacing.unit * size, [size]);

  useEffect(() => {
    pulse.value = 0;
    pulse.value = withRepeat(withTiming(1, { duration: 750, easing: Easing.ease }), -1, true);
  }, [pulse]);

  const animatedStyle = useAnimatedStyle(() => {
    return {
      backgroundColor,
      borderRadius: borderRadius * spacing.unit,
      height: placeholderSize,
      opacity: interpolate(pulse.value, [0, 1], [0.3, 0.5]),
      width: placeholderSize,
    };
  });

  return (
    <Block height={size} width={size} borderRadius={size / 2}>
      <Animated.View style={animatedStyle} />
    </Block>
  );
};

export default React.memo(CirclePlaceholder);
